import { useState } from "react";
import PageHeader from "@/components/layout/PageHeader";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ZoomIn, X } from "lucide-react";
import { IMAGES } from "@/data/site";

export default function GalleryPage() {
  const [active, setActive] = useState(null);

  return (
    <div data-testid="gallery-page">
      <PageHeader
        eyebrow="Galeri"
        title="Atölyemizden"
        accent="kareler."
        subtitle="LPG montajından akü değişimine, periyodik bakımdan diagnostik testlere — günlük çalışmalarımızdan profesyonel kareler."
      />

      <section className="py-12 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 auto-rows-[200px] sm:auto-rows-[220px] lg:auto-rows-[260px] gap-3">
            {IMAGES.gallery.map((img, i) => (
              <button
                key={i}
                data-testid={`gallery-item-${i}`}
                onClick={() => setActive(img)}
                className={`group relative rounded-xl overflow-hidden glass card-lift focus:outline-none focus:ring-2 focus:ring-gold ${
                  img.span || ""
                }`}
              >
                <img
                  src={img.src}
                  alt={img.caption}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent opacity-50 group-hover:opacity-100 transition-opacity" />
                <div className="absolute top-3 right-3 w-9 h-9 rounded-full bg-black/50 backdrop-blur-md border border-white/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all group-hover:scale-110">
                  <ZoomIn className="w-4 h-4 text-gold" />
                </div>
                <div className="absolute bottom-3 left-4 right-4 text-left">
                  <p className="text-white text-sm font-medium drop-shadow-md">
                    {img.caption}
                  </p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent
          className="bg-black/95 border-gold/20 max-w-5xl p-2"
          data-testid="gallery-lightbox"
        >
          {active && (
            <div className="relative">
              <img
                src={active.src}
                alt={active.caption}
                className="w-full max-h-[80vh] object-contain rounded-lg"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-6 rounded-b-lg">
                <p className="text-gold uppercase tracking-[0.25em] text-[10px] font-semibold mb-1">
                  Star Otogaz
                </p>
                <p className="text-white font-medium">{active.caption}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
